import appReducer, { defaultState, type AppState } from "./appReducer";

export { defaultState, type AppState };
export default appReducer;
